import { render, staticRenderFns } from "./NewAndRenewals.vue?vue&type=template&id=002f870e&scoped=true&"
import script from "./NewAndRenewals.vue?vue&type=script&lang=js&"
export * from "./NewAndRenewals.vue?vue&type=script&lang=js&"
import style0 from "./NewAndRenewals.vue?vue&type=style&index=0&id=002f870e&lang=scss&scoped=true&"
import style1 from "./NewAndRenewals.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f870e",
  null
  
)

export default component.exports